module.exports = __webpack_public_path__ + "static/media/welcome_screen.1.86ed48b1.jpg";